<template>
  <el-popover placement="bottom" min-width="278" :offset="40" trigger="click" ref="popover" v-model="show">
    <div class="table-mode-head">
      <div class="tip">
        <span>字段管理</span>
      </div>
      <div class="table-head-key" id="table-head">
        <vuedraggable element="div" class="scroll-inner-wrap" v-bind="dragOptions()" handle=".drag" :list="templateKey" @end="onListEnd">
          <div class="list-item" v-for="(item, index) in templateKey" :key="index" :data-id="item.id" :data-show="item.is_show">
            <span name="head-handle" class="head-handle">
              <i class="icon iconfont iconicon_drag_order tableIconHover drag"></i>
              <a>{{ item.component_name_in_template }}</a>
            </span>
            <el-switch v-model="item.is_show" size="mini" @change="radioChange(index)" :active-value="1" :inactive-value="0"></el-switch>
          </div>
        </vuedraggable>
      </div>
      <div class="footer">
        <span class="text-blue" @click="addKey"><i class="icon iconfont iconicon_new_subproject"></i>添加和管理字段</span>
      </div>
    </div>
    <div slot="reference" class="template-project-head-key--btn filter-status btnHover filter-source">
      <i class="icon iconfont iconicon_field_management1"></i>字段管理
    </div>
  </el-popover>
</template>
<script>
import vuedraggable from "vuedraggable";
export default {
  props: {
    templateKey: {
      type: Array,
      default: () => []
    }
  },
  components: {
    vuedraggable
  },
  data() {
    return {
      show: false,

    }
  },
  methods: {
    onListEnd() {

    },
    addKey() {
      this.$emit('showCustom')
    },
    radioChange() {

    },
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
      };
    },
  },

}
</script>
<style lang="scss">
@import "@/assets/scss/mixin.scss";
.table-mode-head {
  max-height: 100vh;
  overflow-x: hidden;
  width: 278px;
  .head-handle {
    display: flex;
    width: 100%;
    align-items: center;
    i {
      flex-shrink: 0;
    }
    a {
      width: 0;
      flex: 1;
      @include ellipsis();
    }
  }
  .scroll-inner-wrap {
    flex-direction: column;
    width: 100%;
    .el-checkbox__inner::after {
      left: 0 !important;
      top: 1px !important;
    }
  }
  .key-button {
    margin: 16px 11px;
  }
  .tip {
    font-size: 12px;
    height: 64px;
    line-height: 40px;
    padding: 0 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    .icon {
      &:hover {
        cursor: pointer;
      }
    }
    span {
      font-size: 16px;
      font-weight: 500;
    }
    .btn {
      font-size: 14px;
      color: rgba(32, 32, 32, 0.6);
      padding: 4px 6px;
      display: flex;
      align-items: center;
      line-height: 1;
    }
  }
  .table-head-key {
    font-size: 12px;
    max-height: 72vh;
    overflow-x: hidden;
  }
  .list-item {
    display: flex;
    justify-content: space-between;
    padding-left: 20px;
    padding-right: 28px;
    align-items: center;
    cursor: pointer;
    position: relative;
    height: 40px;
    z-index: 9;
    span {
      font-size: 14px;
      i {
        color: rgba(32, 32, 32, 0.4);
        font-size: 14px;
        display: flex;
        align-items: center;
        line-height: 1;
        margin-right: 8px;
      }
    }
  }
  .blue-background-class {
    border: 2px dashed #2682ff;
  }
  .footer {
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: rgba(32, 32, 32, 0.8);
    border-top: 1px solid rgba(32, 32, 32, 0.08);
    margin-top: 8px;
    span {
      padding: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      i {
        font-size: 14px;
        margin-right: 9px;
      }
    }
  }
}
.template-project-head-key--btn {
  padding: 8px;
  font-size: 14px;
  color: rgba(32, 32, 32, 0.6);
  display: flex;
  align-items: center;
  i {
    margin-right: 8px;
    font-size: 14px;
  }
}
</style>
